import { render, staticRenderFns } from "./groupsend.vue?vue&type=template&id=969106da&scoped=true"
import script from "./groupsend.vue?vue&type=script&lang=js"
export * from "./groupsend.vue?vue&type=script&lang=js"
import style0 from "./groupsend.vue?vue&type=style&index=0&id=969106da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969106da",
  null
  
)

export default component.exports